function ownKeys(e, r) { var t = Object.keys(e); if (Object.getOwnPropertySymbols) { var o = Object.getOwnPropertySymbols(e); r && (o = o.filter(function (r) { return Object.getOwnPropertyDescriptor(e, r).enumerable; })), t.push.apply(t, o); } return t; }
function _objectSpread(e) { for (var r = 1; r < arguments.length; r++) { var t = null != arguments[r] ? arguments[r] : {}; r % 2 ? ownKeys(Object(t), !0).forEach(function (r) { _defineProperty(e, r, t[r]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : ownKeys(Object(t)).forEach(function (r) { Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r)); }); } return e; }
function _defineProperty(e, r, t) { return (r = _toPropertyKey(r)) in e ? Object.defineProperty(e, r, { value: t, enumerable: !0, configurable: !0, writable: !0 }) : e[r] = t, e; }
function _toPropertyKey(t) { var i = _toPrimitive(t, "string"); return "symbol" == typeof i ? i : i + ""; }
function _toPrimitive(t, r) { if ("object" != typeof t || !t) return t; var e = t[Symbol.toPrimitive]; if (void 0 !== e) { var i = e.call(t, r || "default"); if ("object" != typeof i) return i; throw new TypeError("@@toPrimitive must return a primitive value."); } return ("string" === r ? String : Number)(t); }
import isEqual from 'lodash/isEqual';
import { arrayUrlValues, isA } from '../utils';
class MultiValueFilter {
  constructor(available, selected, defaultSelected) {
    this.default = defaultSelected || [];
    this.available = available || [];
    this.availableMap = available.reduce((map, value) => _objectSpread(_objectSpread({}, map), {}, {
      [value.name]: value
    }), {});
    this.selected = selected ? selected.filter(each => this.availableMap[each] !== undefined) : this.default;
  }
  isEmpty() {
    return this.selected ? this.selected.length === 0 : true;
  }
  isDefault() {
    return isEqual(this.selected.slice().sort(), this.default.slice().sort());
  }
  hasValue(value) {
    return this.selected.includes(value);
  }
  hasOnlyValue(value) {
    return this.hasValue(value) && this.selected.length === 1;
  }
  getValues() {
    return this.selected;
  }
  getSingleValue() {
    return this.selected && this.selected.length === 1 ? this.selected[0] : null;
  }
  toUrlParameter(name) {
    if (this.isDefault()) {
      return null;
    }
    if (this.isEmpty()) {
      return {
        [name.toLowerCase()]: ''
      };
    }
    return arrayUrlValues(name, this.selected.map(each => this.availableMap[each].urlSlug));
  }
  isMultiValueFilter() {
    return true;
  }
}
MultiValueFilter.isInstance = value => isA(value, 'MultiValueFilter');
export default MultiValueFilter;